
import * as marietta from '../../..';
import { BUILDING_TYPE_MANSION } from '../../../webcad/Constants';
import * as THREE from 'three';
import { ThreeView } from '../../../view3d/webcad';
import { pix2D, Unit } from '../../graphicLibs/util/unit';
import { PinInfo, PinType } from '../PinInfo';


export class AddPin2D {
    
    private enabled: boolean = true; //ピン配置有効化フラグ
    private docList = [];

    constructor(private pinDatas: PinType[][]) {
        if (ThreeView.get().buildingDocument == null) return;
        this.docList = ThreeView.get().buildingDocument.docList;
    }

    public execute(floor: number) {

        const cameraData: PinType[] = this.pinDatas[floor-1];
        // ピン配置情報があるか見る
        if (cameraData == null) return;

        if (Array.isArray(this.docList) && this.docList.length > 0) {
            this.setPin(cameraData, floor);
        }

    }

    private setPin(cameraData: PinType[], floor: number) {
        // 存在したらピン配置
        const infos = [];
        for (let i = 0; i < cameraData.length; i++) {
            const data = cameraData[i];            
            const document = this.docList.find((doc) => doc.file_name == data.imagePath);
            if (document == null || document.file_path == '') continue;
            const path = document.file_path; 
            const info = this.createItem(floor, data, path);
            infos.push(info);
        }

        if (this.enabled) {
            marietta.webcad.util.WebcadJSONParser.reproduceFreeTextItem(infos);
            marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
        }
    }

    /**
     * テキストアイテムの作成
     */
    private createItem(floor: number, data: PinType, linkUrl: string) {
        const center2D = new THREE.Vector2(marietta.webcad.WebCADGlobal.LAYER_SIZE_W/2, marietta.webcad.WebCADGlobal.LAYER_SIZE_H/2);
        const pix = <pix2D>new THREE.Vector2(center2D.x, center2D.y);
        const layerSizeH = marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H);

        const x = data.position.x; 
        const y = data.position.z;
        const linkName = data.imagePath;

        const elements = data.matrix.elements;
        /** 位置 算出 **/
        elements[12] = x * 1000 + Unit.convertPixtoMm(pix).x; // 3D座標系 x座標 mm
        elements[14] = layerSizeH - (Unit.convertPixtoMm(pix).y - y * 1000); // 3D座標系 z座標 mm

        elements[13] = data.height; // 階高さ mm
        data.matrix.elements = elements;

        /** 角度 算出 **/
        const dir = new THREE.Vector3(elements[8], 0, elements[10]).normalize();
        let rotation = 0;
        // 真上・真下の場合、計算ができないので、rotationは0とする。
        if (dir.equals(new THREE.Vector3(0, 0, 0)) == false) {
            const rad = new THREE.Vector3(0, 0, 1).angleTo(dir);
            const sin = new THREE.Vector3(0, 0, 1).clone().cross(dir);
            rotation = sin.y > 0 ? - THREE.MathUtils.radToDeg(rad) : THREE.MathUtils.radToDeg(rad);
        }
        
        const info: any = {};
        info.index = 0;
        info.id = 'txt03_01';
        info.guid = marietta.webcad.WebCADGlobal.getGuid();
        info.f = floor;
        info.rotation = rotation;
        if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
            info.x = x * 1000 + Unit.convertPixtoMm(pix).x;
            info.y = Unit.convertPixtoMm(pix).y - y * 1000;
        } else {
            info.x = marietta.webcad.util.WebCADUtil.convertMMToPix(x * 1000) + pix.x;
            info.y = pix.y - marietta.webcad.util.WebCADUtil.convertMMToPix(y * 1000);
        }
        info.z = 0;
        const textAttribute = marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute;
        info.text = '';
        info.text_color = textAttribute.text_color;
        info.font_size = textAttribute.font_size;
        info.is_bold = textAttribute.is_bold;
        info.is_italic = textAttribute.is_italic;
        info.is_strike_through = textAttribute.is_strike_through;
        info.is_underline = textAttribute.is_underline;
        info.text_alignment = textAttribute.text_alignment;
        info.link = [{ name: linkName, url: linkUrl }];
        const textSize = marietta.webcad.util.TextUtil.getTextSizeWh('', marietta.webcad.WebCADGlobal.freeTextFontFamily, marietta.webcad.WebCADGlobal.webcad2Dmanager.textAttribute.font_size);
        info.width = textSize.width;
        info.height = textSize.height;
        let matrix = data.cameraMatrix.ARKitToWebcad(data.matrix);
        matrix = data.cameraMatrix.scale1x(matrix);
        info.transformMatrix = matrix.elements;

        return info;
    }

}